export const volpara = {
    fontFamilyImport: [],
  transitionMain: "all 300ms ease-in-out",

  fieldTopSpacing: 25,
  inputPaddingInline: 15,

  inputHeight: 45,
  inputWidth: '100',
  inputWidthUnits: "%",

  inputFontSize: 18,
  inputFontFamily: '"Lato", sans-serif',
  inputColor: "#3C5164",
  inputBackgroundColor: "#ffffff",
  inputFontWeight: 400,

  inputBorderColor: "#FFFFFF",
  inputBorderWidth: 1,
  inputBorderRadius: 0,

  inputHoverColor: "#3C5164",
  inputHoverBorderColor: "#FFFFFF",
  inputHoverBackgroundColor: "#ffffff",

  // **********************************
  //  Select field
  selectTopSpacing: 25,
  selectPaddingInline: 15,

  selectHeight: 45,
  selectWidth: '100',
  selectWidthUnits: "%",

  selectFontSize: 18,
  selectFontFamily: '"Lato", sans-serif',
  selectColor: "#3C5164",
  selectBackgroundColor: "#F0F0F0",
  selectFontWeight: 400,

  selectBorderColor: "#FFFFFF",
  selectBorderWidth: 1,
  selectBorderRadius: 0,

  selectHoverColor: "#3C5164",
  selectHoverBorderColor: "#FFFFFF",
  selectHoverBackgroundColor: "#F0F0F0",

  addSelectBackgroundImage: false,
  selectBackgroundImage: '',
  selectBackgroundImagePositionRight: 10,
  selectBackgroundImageSize: 20,

  // **********************************
  //  Text Area field
  textAreaTopSpacing: 25,
  textAreaPaddingInline: 15,

  textAreaHeight: 75,
  textAreaWidth: '100',
  textAreaWidthUnits: "%",

  textAreaFontSize: 18,
  textAreaFontFamily: '"Lato", sans-serif',
  textAreaColor: "#3C5164",
  textAreaBackgroundColor: "#ffffff",
  textAreaFontWeight: 400,

  textAreaBorderColor: "#FFFFFF",
  textAreaBorderWidth: 1,
  textAreaBorderRadius: 0,

  textAreaHoverColor: "#3C5164",
  textAreaHoverBorderColor: "#FFFFFF",
  textAreaHoverBackgroundColor: "#ffffff",

  // **********************************
  //  placeholder
  placeholderColor: "#3C5164",
  placeholderFontFamily: '"Lato", sans-serif',
  placeholderFontSize: 18,
  placeholderFontWeight: 400,
  placeholderHoverColor: "#3C5164",

  // **********************************
  // script
  addPlaceholders: false,
  removeFieldLabels: false,

  // **********************************
  //  field label
  fieldLabelBottomSpacing: 13,
  fieldLabelPadding: 0,
  fieldLabelFontSize: 18,
  fieldLabelColor: "#FFFFFF",
  fieldLabelFontWeight: 400,
  fieldLabelColorAsterisk: "#FFFFFF",
  fieldLabelAlignment: "column",
  fieldLabelFontFamily: '"Lato", sans-serif',

  // **********************************
  //  description
  descriptionPaddingInline: 0,
  descriptionColor: "#FFFFFF",
  descriptionFontSize: 18,
  descriptionFontWeight: 400,
  descriptionFontFamily: '"Lato", sans-serif',
  descriptionTopSpacing: 10,

  // **********************************
  // checkbox

  addCheckbox: false,
  checkedCheckboxContent: "",
  checkboxInputSize: 18,
  checkboxBorderWidth: 1,
  checkboxBorderRadius: 0,
  checkboxUncheckedBorderColor: "#FFFFFF",
  checkboxUncheckedBackgroundColor: "#FFFFFF",
  checkboxCheckedBackgroundColor: "#FFFFFF",
  checkboxCheckedBorderColor: "#FFFFFF",
  checkboxCheckedColor: "#3C5164",
  checkboxAlignment: "none",
  checkboxLabelFontFamily: '"Lato", sans-serif',
  checkboxLabelFontSize: 18,
  checkboxLabelFontWeight: 400,
  checkboxLabelColor: "#FFFFFF",

  // **********************************
  // radio button

  addRadioButton: false,
  radioInputSize: 18,
  radioBorderWidth: 1,
  radioBorderRadius: 50,

  radioUncheckedBorderColor: "#FFFFFF",
  radioUncheckedBackgroundColor: "#FFFFFF",
  radioCheckedBackgroundColor: "#3C5164",
  radioCheckedBorderColor: "#FFFFFF",

  radioAlignment: "none",

  radioLabelFontFamily: '"Lato", sans-serif',
  radioLabelFontSize: 18,
  radioLabelFontWeight: 400,
  radioLabelColor: "#FFFFFF",

  // **********************************
  // submit button

  submitMarginTop: 43,
  submitFontSize: 22,
  submitFontFamily: "'Lato', sans-serif",
  submitWidth: 214,
  submitWidthUnits: "px",
  submitHeight: 57,
  submitBorderRadius: 8,
  submitBorderWidth: 2,
  submitBackground: "#3C5164",
  submitColor: "#FFFFFF",
  submitBorderColor: "#FFFFFF",
  submitBackgroundHover: "#3C5164",
  submitBorderColorHover: "#FFFFFF",
  submitColorHover: "#FFFFFF",
  submitTextAlign: "center",
  submitButtonText: "Submit",
  submitFontWeight: 700,
  addBackgroundImage: false,
  submitBackgroundImage: '',
  submitBackgroundImagePositionRight: 10,
  submitBackgroundImageSize: 20,
  submitButtonAlign: "center",
};

  